import MiniQTable from "./MiniQTable";
import MiniQ2Table from "./MiniQ2Table";


const ManagerSensorsTable = ({item, t}) => {
    switch (item.model) {
        case "MQ-SX":
            return <MiniQTable item={item} t={t}/>;
        case "MQ2-4G":
            return <MiniQ2Table item={item} t={t}/>;
        default:
            break;
    }
}
export default ManagerSensorsTable;